import { z } from 'zod'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ValidationMessageKeys } from 'src/Configuration/validation'

const MAX_STRING_LENGTH = 50

interface ReturnType {
  vehicleSettingsFormSchema: z.Schema
}

export const useValidateVehicleSettingsForm = (): ReturnType => {
  const { t } = useCustomTranslation()

  const vehicleSettingsFormSchema = z.object({
    customImage: z.union([z.instanceof(File), z.literal(''), z.null()]),
    customName: z.preprocess(
      value => value ?? '',
      z.string().max(MAX_STRING_LENGTH, t(ValidationMessageKeys.lengthMax, { value: MAX_STRING_LENGTH }))
    ),
  })

  return { vehicleSettingsFormSchema }
}
